import { useEffect, useState } from "react";
import { Container, Nav } from "react-bootstrap";
import { Route, BrowserRouter as Router, Routes, Navigate, useNavigate } from "react-router-dom";
import NavbarComponent from "./components/NavbarComponent";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import Register from "./pages/Register";
import Workout from "./pages/Workout";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false)

 
  let token = localStorage.getItem("token");
 
   useEffect(() => {
     if (token !== null) {
       setIsLoggedIn(true);
     }
   }, [token])
  

 

  return (
    
    <Router>
      <NavbarComponent isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn}   />
      <Container>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/workout" element={<Workout />} />
        </Routes>
      </Container>
    </Router>
    
  );
}

export default App;
